export enum AuthenticationMethod {
    OKTA = "OKTA",
    KEYCLOAK = "KEYCLOAK",
}
